import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

export const getMfaContactSelectFormSchema = () =>
  yup.object().shape({
    contact: yup.string().required(i18n("MfaContactSelectForm__CONTACT_REQUIRED")),
    termsAgree: yup
      .boolean()
      .oneOf([true], i18n("MfaContactSelectForm__TERMS_AGREE_REQUIRED"))
      .required(i18n("MfaContactSelectForm__TERMS_AGREE_NOT_VALID")),
  });
